import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {SetCountryService} from 'src/app/data/utils/set-country.service';
import {customer} from '../../api/customer/customer.api';
import {RequestService} from '../../../handlers/request/request.service';

import {Logout} from '../../models/customer/requests/logout';
import {ValidateSmsToken} from '../../models/customer/requests/validate-sms-token';
import {ValidateCustomer} from '../../models/customer/requests/validate-customer';
import {Create, CreateParams} from '../../models/customer/requests/create';
import {Update} from '../../models/customer/requests/update';
import {ChangePassword, ResetPassword} from '../../models/customer/requests/password';
import {KeyClient} from '../../models/shared/requests/key-client';
import {Login, LoginBmc} from '../../models/customer/requests/login';
import {Interests} from '../../models/customer/requests/interests';
import {UserOrigin} from '../../models/customer/requests/get-user-origin';
import {GetCustomer} from '../../models/customer/requests/get';
import {globalEnv} from '../../connection/global/global.env';
import {SaveNonStockItem} from '../../models/customer/requests/save-non-stock-item';
import {SaveNonStockItemRes} from '../../models/customer/responses/save-non-stock-item-res';
import {OptionsIdOtpInterface} from '../../models/customer/requests/code-otp';
import {TokenJwtRequest} from '../../models/shared/requests/token-jwt.request';
import {TokenJwtResponse} from '../../models/shared/responses/token-jwt.response';
import {GenericResponseInterface} from '../../models/shared/responses/generic-response';
import {LoginBmcResponse} from '../../models/customer/responses/login-res';
import {VerifyCustomerRes} from '../../models/customer/responses/verify-customer-res';
import {CreatedCustomerRes, iResponseVerifyUser} from '../../models/customer/responses/customer-res';

@Injectable({
  providedIn: 'root',
})
export class CustomerService {
  constructor(private req: RequestService,private setCountryService: SetCountryService) {}

  get(params: GetCustomer): Observable<any> {
    const endPoint = this.setCountryService.changeUrl(customer.get);
    return this.req.get(`${globalEnv.multiCountry}${endPoint}`, null, null, false);
  }

  create(data: Create, params?: CreateParams): Observable<CreatedCustomerRes> {
    const endPoint = this.setCountryService.changeUrl(customer.create);
    return this.req.post(`${globalEnv.multiCountry}${endPoint}`, data, params);
  }

  createCustomerCallCenter(data, params): Observable<any> {
    return this.req.post(
      `${globalEnv.be2}${customer.createCallCenter}`,
      data,
      params,
      false,
      false,
    );
  }

  validateToken(data): Observable<any> {
    const endPoint = this.setCountryService.changeUrl(customer.validateCodeOTP);
    return this.req.post(`${globalEnv.multiCountry}${endPoint}`, data, null, null,null, null, null, true);
  }

  validateSmsToken(data: ValidateSmsToken, params: any): Observable<any> {
    const endPoint = this.setCountryService.changeUrl(customer.validateSmsToken);
    return this.req.post(`${globalEnv.multiCountry}${endPoint}`, data, params);
  }

  validateCodeToken(data): Observable<any> {
    const endPoint = this.setCountryService.changeUrl(customer.validateCodeRegister);
    return this.req.post(`${globalEnv.multiCountry}${endPoint}`, data);
  }

  validateSmsTokenFinal(params: KeyClient): Observable<any> {
    const endPoint = this.setCountryService.changeUrl(customer.validateSmsTokenFinal);
    return this.req.get(`${globalEnv.multiCountry}${endPoint}`, params);
  }

  validateWhatsapp(data): Observable<any> {
    return this.req.post(
      `${globalEnv.cloudFunction}${customer.validateWhatsapp}`,
      data,
      null,
      null,
      false,
    );
  }

  validateCustomer(params: ValidateCustomer): Observable<any> {
    const endPoint = this.setCountryService.changeUrl(customer.validate);
    return this.req.get(`${globalEnv.multiCountry}${endPoint}`, params);
  }

  update(data: Update): Observable<any> {
    const endPoint = this.setCountryService.changeUrl(customer.update);
    return this.req.put(`${globalEnv.multiCountry}${endPoint}`, data);
  }

  changePassword(data: ChangePassword): Observable<any> {
    const endPoint = this.setCountryService.changeUrl(customer.changePassword);
    return this.req.put(`${globalEnv.multiCountry}${endPoint}`, data,
      null, null, null, null, null, null,
    );
  }

  createPassword(data): Observable<any> {
    const endPoint = this.setCountryService.changeUrl(customer.changePasswordOtp);
    return this.req.put(`${globalEnv.multiCountry}${endPoint}`, data, null, null,null); 
  }

  resetPassword(data: ResetPassword, params: KeyClient): Observable<any> {
    return this.req.post(`${globalEnv.be2}${customer.resetPassword}`, data, params);
  }

  login(params: Login, provider: string): Observable<any> {
    const api =
      provider === 'EMAIL'
        ? customer.login
        : provider === 'GOOGLE'
        ? customer.loginGoogle
        : customer.loginFacebook;
    return this.req.get(`${globalEnv.be2}${api}`, params);
  }

  loginPost(data: Login, provider: string): Observable<any> {
    if (provider === 'EMAIL') {
      const endPoint = this.setCountryService.changeUrl(customer.loginPost);
      return this.req.post(`${globalEnv.multiCountry}${endPoint}`, data, null, null,null, null, null, true);
    } else {
      const params = { ...data, platformSource: provider};
      const endPoint = this.setCountryService.changeUrl(customer.loginSocialPlatforms);
      return this.req.post(`${globalEnv.multiCountry}${endPoint}`, params);
    }
  }
  
  loginBmc(params: LoginBmc): Observable<LoginBmcResponse> {
    const endPoint = this.setCountryService.changeUrl(customer.loginBmc);
    return this.req.post(`${globalEnv.multiCountry}${endPoint}`, params, null, null, null);
  }

  logOut(params: Logout): Observable<any> {
    return this.req.put(`${globalEnv.be2}${customer.deleteDevice}`, params, null, null, true);
  }

  createCustomerInterests(data: Interests, params: KeyClient): Observable<any> {
    return this.req.post(`${globalEnv.be2}${customer.interests}`, data, params, true);
  }

  getUserOrigin(data: UserOrigin): Observable<iResponseVerifyUser> {
    const endPoint = this.setCountryService.changeUrl(customer.getUserOrigin);
    return this.req.post(`${globalEnv.multiCountry}${endPoint}`, data, null, null,null);
  }

  getCustomerByPhoneNumberOrDocumentNumber(data): Observable<any> {
    return this.req.post(
      `${globalEnv.be2}${customer.getCustomerByPhoneNumberOrDocumentNumber}`,
      data,
      null,
      null,
    );
  }

  getCustomerByDocumentId(data): Observable<any> {
    return this.req.post(
      `${globalEnv.be2}${customer.getCustomerByDocumentId}`,
      data,
      null,
      null,
      true,
    );
  }

  sendMessage(data: OptionsIdOtpInterface, withoutCustomer = false): Observable<GenericResponseInterface> {
    const endPoint = this.setCountryService.changeUrl(withoutCustomer ? customer.sendCodeRegisterExpress : customer.sendCode);
    return this.req.post(`${globalEnv.multiCountry}${endPoint}`, data, null, null,null);
  }

  customerOnly(params): Observable<any> {
    return this.req.get(`${globalEnv.be2}${customer.customerOnly}`, params, null);
  }

  yunoCheckoutToken(id: number, gateway: string): Observable<any> {
    return this.req.get(`${globalEnv.yuno}${customer.yunoToken}`, {id, gateway}, undefined, true);
  }
  gatewayActive(city: string): Observable<any> {
    return this.req.get(`${globalEnv.be2}${customer.gatewayActive}`, {city}, undefined, true);
  }

  saveNonStockItem(data: SaveNonStockItem): Observable<SaveNonStockItemRes> {
    return this.req.post(`${globalEnv.gateway}${customer.saveNonStockItem}`, data, null, null, null, null, null, null);
  }

  getSaveNonStockItem(email: string): Observable<SaveNonStockItemRes> {
    return this.req.get(`${globalEnv.gateway}${customer.getSaveNonStockItem}/${email}/nonStockItems`, null, null, null, null, null, null, null);
  }

  removeNonStockItem(data: SaveNonStockItem): Observable<SaveNonStockItemRes> {
    return this.req.post(`${globalEnv.gateway}${customer.removeNonStockItem}`, data, null, null, null, null, null, null);
  }

  refreshTokensJwt(refreshToken: string): Observable<TokenJwtResponse> {
    const headers = {
      'source': 'WEB',
      'Authorization': `Bearer ${refreshToken}`
    };
    const endPoint = this.setCountryService.changeUrl(customer.tokenJwt.refresh);
    return this.req.get(`${globalEnv.multiCountry}${endPoint}`, null, null, null, null, null, headers, null);
  }

  createTokenJwt(data: TokenJwtRequest): Observable<TokenJwtResponse> {
    const endPoint = this.setCountryService.changeUrl(customer.tokenJwt.create);
    return this.req.post(`${globalEnv.multiCountry}${endPoint}`, data, null, null, null, null, null, null);
  } 
  
  verifyCustomer(customerId: number): Observable<VerifyCustomerRes> {
    return this.req.get(`${globalEnv.gateway}${customer.verifyCustomer}`, {customerId}, null, false);
  }
}
